interface ThreeThirtyLogoProps {
  size?: number;
  className?: string;
  variant?: 'vector' | 'image' | 'badge';
}

export function ThreeThirtyLogo({ size = 26, className = '', variant = 'badge' }: ThreeThirtyLogoProps) {
  if (variant === 'image') {
    return (
      <img
        src="/three-thirty-logo.png"
        alt="THREE THIRTY LLC"
        width={size * 1.4}
        height={size}
        className={className}
        style={{ display: 'inline-block', verticalAlign: 'middle', objectFit: 'contain', borderRadius: '4px' }}
      />
    );
  }

  // Clean vector representation of 3 3 0 (Green, Gold, Green with center dot)
  const width = size * 1.42;
  const height = size;

  if (variant === 'badge') {
    return (
      <div
        className={`three-thirty-badge ${className}`}
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          background: '#eef2ee',
          borderRadius: '8px',
          padding: '2px 6px',
          boxShadow: '0 1px 3px rgba(0, 0, 0, 0.1)',
        }}
      >
        <svg
          width={width}
          height={height}
          viewBox="0 0 142 100"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-label="Three Thirty 330 Logo"
        >
          {/* First 3 (Forest Green) */}
          <text
            x="24"
            y="76"
            textAnchor="middle"
            fontFamily="'Plus Jakarta Sans', system-ui, -apple-system, sans-serif"
            fontSize="84"
            fontWeight="700"
            fill="#1e4632"
          >
            3
          </text>

          {/* Second 3 (Warm Ochre Gold) */}
          <text
            x="71"
            y="76"
            textAnchor="middle"
            fontFamily="'Plus Jakarta Sans', system-ui, -apple-system, sans-serif"
            fontSize="84"
            fontWeight="700"
            fill="#b88a44"
          >
            3
          </text>

          {/* 0 with center dot (Forest Green) */}
          <text
            x="118"
            y="76"
            textAnchor="middle"
            fontFamily="'Plus Jakarta Sans', system-ui, -apple-system, sans-serif"
            fontSize="84"
            fontWeight="700"
            fill="#1e4632"
          >
            0
          </text>
          {/* Central dot inside 0 */}
          <circle cx="118" cy="46.5" r="7" fill="#1e4632" />
        </svg>
      </div>
    );
  }

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 142 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={{ display: 'inline-block', verticalAlign: 'middle', flexShrink: 0 }}
      aria-label="Three Thirty 330 Logo"
    >
      <text
        x="24"
        y="76"
        textAnchor="middle"
        fontFamily="'Plus Jakarta Sans', system-ui, -apple-system, sans-serif"
        fontSize="84"
        fontWeight="700"
        fill="#ffffff"
      >
        3
      </text>
      <text
        x="71"
        y="76"
        textAnchor="middle"
        fontFamily="'Plus Jakarta Sans', system-ui, -apple-system, sans-serif"
        fontSize="84"
        fontWeight="700"
        fill="#f59e0b"
      >
        3
      </text>
      <text
        x="118"
        y="76"
        textAnchor="middle"
        fontFamily="'Plus Jakarta Sans', system-ui, -apple-system, sans-serif"
        fontSize="84"
        fontWeight="700"
        fill="#ffffff"
      >
        0
      </text>
      <circle cx="118" cy="46.5" r="7" fill="#ffffff" />
    </svg>
  );
}
